import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth token management utilities
export const authToken = {
    get: () => localStorage.getItem('accessToken'),
    set: (token) => localStorage.setItem('accessToken', token),
    remove: () => localStorage.removeItem('accessToken'),
    exists: () => !!localStorage.getItem('accessToken')
};

// Global logout function
export const logout = async (navigate) => {
    try {
        await axios.post(`${API}/auth/logout`);
    } catch (err) {
        console.error('Logout API error:', err);
    } finally {
        // Always clear local auth even if API fails
        authToken.remove();
        delete axios.defaults.headers.common['Authorization'];
        if (navigate) {
            navigate('/login');
        }
    }
};
